import React from 'react';
import { Link } from 'react-router-dom';

/** Aviso de independência: curto, ao lado da ferramenta, com o link da metodologia. */
export function ToolIndependenceNote() {
  return (
    <section aria-label="Contexto da ferramenta">
      <p className="text-sm leading-relaxed text-[var(--text-muted)]">
        <strong className="text-[var(--primary)]">Ferramenta independente.</strong>{' '}
        O MiniMental.com.br organiza aplicação, pontuação e contexto clínico com referências brasileiras. Não é o formulário oficial do MMSE e não é afiliado ou endossado pela PAR, Inc.
      </p>
      <Link to="/metodologia-da-calculadora" className="mt-2 inline-flex min-h-11 items-center text-[0.9375rem] text-[var(--primary)] underline">
        Como a calculadora funciona →
      </Link>
    </section>
  );
}

/** Base, metodologia e direitos: três notas em colunas separadas por régua. */
export function ToolBasis() {
  const items = [
    { t: 'Base brasileira', d: 'Dados e referências são ligados às populações e métodos dos estudos brasileiros utilizados.', to: '/evidencia-brasileira', l: 'Ver estudos →' },
    { t: 'Metodologia transparente', d: 'Mediana, ponto de corte e mudança longitudinal são tratados como conceitos diferentes.', to: '/metodologia-da-calculadora', l: 'Ver metodologia →' },
    { t: 'Instrumento e licenciamento', d: 'O instrumento oficial, traduções autorizadas e permissões permanecem sob os canais próprios do editor.', to: '/formulario-e-direitos-de-uso', l: 'Direitos e canais oficiais →' },
  ];
  return (
    <section aria-label="Base e direitos da calculadora" className="border-t border-[var(--border-strong)] pt-6">
      <div className="grid gap-6 text-sm md:grid-cols-3 md:gap-0 md:divide-x md:divide-[var(--border)]">
        {items.map((item) => (
          <div key={item.t} className="md:px-6 md:first:pl-0 md:last:pr-0">
            <p className="mb-1 font-semibold text-[var(--primary)]">{item.t}</p>
            <p className="leading-relaxed text-[var(--text-muted)]">{item.d}</p>
            <Link to={item.to} className="mt-1 inline-flex min-h-11 items-center text-[var(--primary)] underline">{item.l}</Link>
          </div>
        ))}
      </div>
      <p className="mt-6 border-t border-[var(--border)] pt-4 text-sm text-[var(--text-muted)]">
        Mais ferramentas médicas em{' '}
        <a href="https://eidoc.com.br/ferramentas" target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 items-center text-[var(--primary)] underline">
          Ei, Doc! →
        </a>
      </p>
    </section>
  );
}

export default function CalculatorProtectionFrame({ children }) {
  return (
    <>
      <ToolIndependenceNote />
      {children}
      <ToolBasis />
    </>
  );
}
